module.exports = __webpack_public_path__ + "img/calendar_title.96ff7cbe.svg";